<template>
  <v-app id="emma">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="5">
            <p>Overview acco's (D) with house sentences of a temporary nature</p>
          </v-col>
      </v-row>

      <v-row>    
          <v-col cols="1">
             <v-btn class="primary ma-0" small :disabled="results" @click="ovrz">Create excel</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
    <navBar title="Ares - Excel Exports" :home="true" type="excel" />
    <showProgress ref="showProgress"></showProgress>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import showProgress from "@/components/showProgress.vue";
 export default {
  components: {
    navBar,
    showProgress
  },
  data() {
    return {
      results: false,
      param: {}
    }
  },
  created() {
  },
  methods: {
     ovrz() {
      this.results = true;
      this.$refs.showProgress.open();
      this.$axios
        .post("ares/json/ares/task/excel/tmp/emma.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "emma"
          },
          emma: {}
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.emma;
            this.$refs.showProgress.close();
            this.results = false;
            window.open(this.items.filename,'_blank');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
